import { AlertButton, AlertController, AlertInput, LoadingController, MenuController, ModalController, NavController, Platform, PopoverController, ToastButton, ToastController } from '@ionic/angular';
import { HttpService } from '../data/service/http.service';
import { Location } from '@angular/common';
import { AppSettings } from '../../configs/app.settings';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { AppComponent } from 'src/app/app.component';
import { Log } from '../log';

export class ServiceHelper {

    static navCtrl: NavController;
    static platform: Platform;
    static popoverCtrl: PopoverController;
    static loadCtrl: LoadingController;
    static alertCtrl: AlertController;
    static toastCtrl: ToastController;
    static httpSvc: HttpService;
    static title: Title;
    static menuCtrl: MenuController;
    static modalCtrl: ModalController;
    static sanitizer: DomSanitizer;
    static location: Location;
    static appComponent: AppComponent;

    // store the routing history, newest should be first
    static routeHistory: string[] = [];

    static get AppSettings() { return AppSettings; }

    static setLocation(url: string) {
        ServiceHelper.location.go(url);
    }

    static async wait(ms: number) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    static async displayAlert(title: string, message: string, buttons: (string | AlertButton)[] = ['OK']): Promise<HTMLIonAlertElement> {
        const alert = await ServiceHelper.alertCtrl.create({
            header: title,
            message,
            buttons,
            cssClass: 'custom-alert',
        });
        await alert.present();
        return alert;
    }

    static async displayLoad(message: string) {
        const load = await ServiceHelper.loadCtrl.create({
            message
        });
        load.present();
        return load;
    }

    static async displayToast(message: string, duration: number = 2000, buttons: ToastButton[] = [], position: 'top' | 'bottom' | 'middle' = 'top') {
        const toast = await ServiceHelper.toastCtrl.create({ message, position, duration, buttons });
        await toast?.present();
        return toast;
    }

    static async back(defaultBack: string) {
        // super hacky, lets see if window location changes to know if pop worked...
        const beforeLocation = window.location.href;
        await ServiceHelper.navCtrl.pop();

        if (beforeLocation === window.location.href) {
            // we went nowhere, use default
            ServiceHelper.navCtrl.navigateBack(defaultBack);
        }
    }

    static async confirmSomething(title: string, body: string, cancelLbl: string = 'Cancel', confirmLbl: string = 'Confirm', additionalButtonText?: string): Promise<boolean> {
        return new Promise(async (resolve) => {
            // create modal alert
            const confirmationAlert = await this.alertCtrl?.create({
                header: title,
                message: body,
                buttons: [
                    {
                        text: cancelLbl,
                        role: 'cancel',
                        handler: () => resolve(false)
                    },
                    {
                        text: confirmLbl,
                        handler: () => resolve(true)
                    }
                ]
            });
            confirmationAlert?.present();
        });
    }

    static async getChoiceSelection(title: string, body: string, cancelLbl: string = 'Cancel', yesLbl: string = 'Yes', noLbl: string = 'No'): Promise<ChoiceSelectValue> {
        return new Promise(async (resolve) => {
            // create modal alert
            const confirmationAlert = await this.alertCtrl?.create({
                header: title,
                message: body,
                buttons: [
                    {
                        text: cancelLbl,
                        role: 'cancel',
                        handler: () => resolve(ChoiceSelectValue.Cancel)
                    },
                    {
                        text: yesLbl,
                        handler: () => resolve(ChoiceSelectValue.Yes)
                    },
                    {
                        text: noLbl,
                        handler: () => resolve(ChoiceSelectValue.No)
                    }
                ]
            });
            confirmationAlert?.present();
        });
    }

    static async getValue(title: string, body: string, cancelLbl: string = 'Cancel', confirmLbl: string = 'Confirm',
        inputType: 'text' | 'number' | 'checkbox' | 'radio' | 'textarea' = 'text', radioLabels?: string[], radioValues?: number[]) {
        return new Promise(async (resolve) => {

            const inputs: AlertInput[] = [];
            if (inputType == 'radio') {
                for (let i = 0; i < radioLabels.length; i++) {
                    inputs.push({
                        type: 'radio',
                        label: radioLabels[i],
                        value: radioValues[i],
                        checked: false
                    });
                }
            } else {
                inputs.push({
                    name: 'value',
                    type: inputType, //isNumber ? 'number' : 'text',
                    placeholder: 'Value',
                });
            }
            Log.debug('create alert with inputs: ', inputs);

            // create modal alert
            const confirmationAlert = await this.alertCtrl?.create({
                header: title,
                message: body,
                buttons: [
                    {
                        text: cancelLbl,
                        role: 'cancel',
                        handler: () => resolve(null)
                    },
                    {
                        text: confirmLbl,
                        handler: (data: any) => {
                            Log.debug('confirm alert confirm pressed,  handle data: ', data);
                            resolve(data);
                        }
                    }
                ],
                inputs
            });
            confirmationAlert?.present();
        });
    }
}


export enum ChoiceSelectValue {
    Cancel = 0,
    Yes = 1,
    No = 2
}
